// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"a3e7f83b","178":"7b18dc34","216":"7f4c6112","399":"3cdc9a82","453":"9dce8499","798":"9075b9f7","856":"fd5d4c39"}[chunkId] + ".chunk.js";
};